export default {
    setExpressAndComputeTotal({commit, state}, value) {
        commit('setExpress', value)

        if (state.cards.totalWithPort !== null) {
            commit('setTotalWithPort', value ? state.cards.totalWithPort + 30 : state.cards.totalWithPort - 30)
        }
    }
}
